import { Outlet, useNavigate } from '@buzola/router'
import { useIdentity, useProjectUserRoles } from '@contember/interface'
import { useEffect } from 'react'
import { Shell } from '~/app/components/layout'
import { AdminNavigation } from '~/app/components/navigation'

export default function AdminLayout() {
	const identity = useIdentity()
	const roles = useProjectUserRoles()
	const navigate = useNavigate()
	// `roles` is empty until the identity loads, so only decide once it's ready —
	// otherwise we'd bounce a valid super-admin during the initial load.
	const loaded = identity !== undefined
	const isSuperAdmin = roles.has('admin')

	// Server-side ACL already denies org-scoped users the data on these pages;
	// this redirect just avoids rendering broken empty super-admin screens.
	useEffect(() => {
		if (loaded && !isSuperAdmin) navigate('app', { replace: true })
	}, [loaded, isSuperAdmin, navigate])

	if (!loaded || !isSuperAdmin) return null

	return (
		<Shell navigation={<AdminNavigation />} logoText="Roj Cloud · Admin">
			<Outlet />
		</Shell>
	)
}
